import { fetchAuthSession } from 'aws-amplify/auth'
import { post } from 'aws-amplify/api';

const PostRequest = async (request) => {
    try {
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        const restOperation = post({
            apiName: 'swfServerlessStripe',
            path: '/',
            options: {
                headers: {
                    Authorization: authToken,
                    'Content-Type': 'application/json'
                },
                body: request
            }
        });
        const response = await restOperation.response;
        // Read the response as text 
        const text = await response.body.text();
        // Parse the text to JSON
        const jsonResponse = JSON.parse(text);
        return jsonResponse;
    } catch (e) {
        console.log('post call failed: ', JSON.parse(e.response.body));
    }
}

export default PostRequest;
